import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import AboutTab from '../../components/tabs/about';
import { BackendIcon, DesignIcon, FrontendIcon } from '../../components/icons';
import AboutProps from '../../model/about-props';

export default function About(props: AboutProps){

    return(
        <Container>
            <Grid mt={!props.isMobile ? 20 : 5} pt={!props.isMobile ? 0 : 3} mb={10} container spacing={0} justifyContent={"space-between"} alignItems={"center"}>
                <Grid item md={5} sm={12}>
                    <Box>
                        <AboutTab
                            endIcon={<DesignIcon fontSize='large' color='primary' viewBox="0 0 49 49"/>}
                            description='I value simple content structure, clean design patterns, and thoughtful interactions.'
                            heading='Design'
                            projectCount={4}
                        />

                        <AboutTab
                            endIcon={<FrontendIcon fontSize='large' color='primary' viewBox="0 0 49 49" />}
                            description='I enjoy building things from the ground up and bringing them to life.'
                            heading='Front End'
                            projectCount={9}
                        />

                        <AboutTab
                            endIcon={<BackendIcon fontSize='large' color='primary' viewBox="0 0 49 49" />}
                            description='I enjoy building secured, documented, optimized APIs, Microservice and server utilities.'
                            heading='Back End'
                            projectCount={4}
                        />

                        <AboutTab
                            endIcon={<BackendIcon fontSize='large' color='primary' viewBox="0 0 49 49" />}
                            description='Building intelligent and adaptive systems'
                            heading='Machine learning'
                            projectCount={2}
                        />
                    </Box>
                </Grid>
                <Grid item md={5} sm={12}>
                    <Typography component='h2' variant='body1' color='#fff' fontWeight='medium' sx={{marginBottom:4}}>
                        Introduction
                    </Typography>
                    <Typography component='h2' variant='h4' color='#fff' fontWeight='medium' sx={{ marginBottom: 4 }}>
                        Hey, I am Abhishek Kumar
                    </Typography>
                    <Typography component='h2' variant='h6' color='rgba(255,255,255,72%)' fontWeight='light' sx={{ marginBottom: 6 }}>
                        Before software can be reusable it first has to be usable.
                    </Typography>
                    <Typography component='h2' variant='h6' color='rgba(255,255,255,72%)' fontWeight='light' >
                        I am a Software Engineer with experience in delivering appropriate technology solutions. Comprehensive knowledge of platform development, enterprise architecture, agile methodologies, cloud services, and web-based applications. Innovative change agent with a unique mix of high-level technology direction and deep technical expertise, including published research paper in the field of Machine Learning.
                    </Typography>
                </Grid>
            </Grid>
        </Container>
    );
}
